import React, { useState } from 'react';
import MindARViewer from './components/MindARViewer';
import ProductInfoModal from './components/ProductInfoModal';
import { DoveForm } from './components/forms';
import HelpModal from './components/HelpModal';
import './App.css';

function App() {
  const [isStarted, setIsStarted] = useState(false);
  const [modalState, setModalState] = useState({
    showProductInfo: false,
    showForm: false,
    selectedProduct: null
  });
  const [showHelp, setShowHelp] = useState(false);

  const handleStart = () => {
    setIsStarted(true);
  };


  // Modal handlers
  const handleShowProductInfo = (product) => {
    setModalState({
      showProductInfo: true,
      showForm: false,
      selectedProduct: product
    });
  };

  const handleShowForm = () => {
    setModalState(prev => ({
      ...prev,
      showForm: true,
      showProductInfo: false
    }));
  };

  const handleCloseModals = () => {
    setModalState({
      showProductInfo: false,
      showForm: false,
      selectedProduct: null
    });
  };

  const handleFormSubmit = (formData, result) => {
    console.log('Dove form submitted:', formData);
    console.log('Database save result:', result);
  };

  return (
    <div className="App">
      {!isStarted && (
        <div className="overlay">
          <div className="start-container">
            <div className="logo-container">
              <img
                src="/dove_iso.png"
                alt="Dove Isotype"
                className="dove-iso"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <img
                src="/dove_logo.png"
                alt="Dove Logo"
                className="dove-logo"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
             <h2>Escaneá. Explorá. Descubrí.</h2>
            <p>Apunta tu cámara al código QR para descubrir los productos Dove y dejate sorprender por lo que viene.</p>
            <p className="hashtag">#DoveAllBodyDeo</p>
            <button className="start-button" onClick={handleStart}>
              Comenzar Experiencia
            </button>

            {/*/!* TEMP: Direct form button - DELETE LATER *!/*/}
            {/*<button*/}
            {/*  style={{*/}
            {/*    marginTop: '20px',*/}
            {/*    padding: '10px 20px',*/}
            {/*    backgroundColor: '#f398b6',*/}
            {/*    color: 'white',*/}
            {/*    border: 'none',*/}
            {/*    borderRadius: '5px',*/}
            {/*    cursor: 'pointer'*/}
            {/*  }}*/}
            {/*  onClick={() => {*/}
            {/*    setIsStarted(true);*/}
            {/*    setModalState({*/}
            {/*      showProductInfo: false,*/}
            {/*      showForm: true,*/}
            {/*      selectedProduct: { name: 'Test Product', productData: { id: 'test' } }*/}
            {/*    });*/}
            {/*  }}*/}
            {/*>*/}
            {/*  TEMP: Open Form Directly*/}
            {/*</button>*/}

            {/*/!* TEMP: Direct product info button - DELETE LATER *!/*/}
            {/*<button*/}
            {/*  style={{*/}
            {/*    marginTop: '10px',*/}
            {/*    padding: '10px 20px',*/}
            {/*    backgroundColor: '#e580a3',*/}
            {/*    color: 'white',*/}
            {/*    border: 'none',*/}
            {/*    borderRadius: '5px',*/}
            {/*    cursor: 'pointer'*/}
            {/*  }}*/}
            {/*  onClick={() => {*/}
            {/*    setIsStarted(true);*/}
            {/*    setModalState({*/}
            {/*      showProductInfo: true,*/}
            {/*      showForm: false,*/}
            {/*      selectedProduct: {*/}
            {/*        name: 'Dove All Body Deo',*/}
            {/*        productData: {*/}
            {/*          id: 'dove-all-body-deo',*/}
            {/*          title: 'DOVE ALL BODY DEO',*/}
            {/*          description: 'DESCUBRÍ LA NUEVA LÍNEA DE DESODORANTES DOVE QUE CUIDA TODO TU CUERPO',*/}
            {/*          image1: '/dove_product_1.png',*/}
            {/*          image2: '/dove_product_2.png'*/}
            {/*        }*/}
            {/*      }*/}
            {/*    });*/}
            {/*  }}*/}
            {/*>*/}
            {/*  TEMP: Open Product Info*/}
            {/*</button>*/}
          </div>
        </div>
      )}

      {isStarted && !modalState.showProductInfo && !modalState.showForm && (
        <div className="ar-container">

          <MindARViewer onProductSelect={handleShowProductInfo} onShowHelp={() => setShowHelp(true)} />
        </div>
      )}

      {isStarted && (modalState.showProductInfo || modalState.showForm) && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: '#fff',
          zIndex: 1
        }} />
      )}

      {isStarted && modalState.showProductInfo && modalState.selectedProduct && !modalState.showForm && (
        <ProductInfoModal
          selectedProduct={modalState.selectedProduct}
          onContinue={handleShowForm}
          onClose={handleCloseModals}
        />
      )}

      {isStarted && modalState.showForm && modalState.selectedProduct && (
        <DoveForm
          onSubmit={handleFormSubmit}
          onClose={() => setModalState(prev => ({ ...prev, showForm: false, showProductInfo: true }))}
        />
      )}

      {showHelp && (
        <HelpModal onClose={() => setShowHelp(false)} />
      )}
    </div>
  );
}

export default App;
